"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M6 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m6 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4M6 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m8-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2M8 18a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-1a1 1 0 1 1 0-2 1 1 0 0 1 0 2m8-1a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
}), 'Dashboard');
